import React from 'react';

import '@fontsource/noto-sans';
import { KeycloakProvider } from '@keycloak/keycloak-account-ui';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import ReactDOM from 'react-dom/client';

import ProfileProvider from './ProfileProvider';
import UserAccount from './UserAccount';
import { environment } from './environment';
import { i18n } from './i18n';
import { theme } from './theme';

i18n.init().then(() => {
  ReactDOM.createRoot(document.getElementById('app')!).render(
    <React.StrictMode>
      <KeycloakProvider environment={environment}>
        <ProfileProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <UserAccount />
          </ThemeProvider>
        </ProfileProvider>
      </KeycloakProvider>
    </React.StrictMode>,
  );
});
